import { AxiosInstance } from "axios";

export interface ISystemBanner {
    message: string | null;
}

export class SystemService {
    private apiClient: AxiosInstance;

    constructor(apiClient: AxiosInstance) {
        this.apiClient = apiClient;
    }

    async getBanner(): Promise<ISystemBanner> {
        const response = await this.apiClient.get<ISystemBanner>('system/banner');
        return response.data;
    }
}
